const strings = {
    "LOGO_TEXT":"Academia <br/> Națională de Șah",
    "NAV_HOME":"Principala",
    "NAV_STUDIOS":"Studii",
    "NAV_PRACTISE":"Practică",
    "NAV_CORDINATES":"Coordonatele",
    "NAV_SCHEDULE":"Orar",
    "NAV_STORE":"Magazin",
    "NAV_TOURNAMENT":"Turnee",
    "NAV_LEADS":"Echipe",
    "BUTTON_TOP_UP_FUNDS":"Suplinire cont",
    "BUTTON_DONATE":"Donează",
    "TECHNICAL_SUPPORT":"Asistență tehnică",
    "LEAVE_FEEDBACK":"Feedback",
    "USER_LEVEL":"Nivelul Probă",
    "META_HOME":"Principala",
    "BTN_CONTINUE":"Confirmă",
    "BTN_EDIT":"Editează",
    "BTN_DELETE":"",
    "BTN_CANCEL":"Anulează",
    "BTN_CONFIRM":"Confirmă",
    "BTN_SAVE":"Salvați",
    "MONTH_1":"ianuarie",
    "MONTH_2":"februarie",
    "MONTH_3":"martie",
    "MONTH_4":"aprilie",
    "MONTH_5":"mai",
    "MONTH_6":"iunie",
    "MONTH_7":"iulie",
    "MONTH_8":"august",
    "MONTH_9":"septembrie",
    "MONTH_10":"octombrie",
    "MONTH_11":"noiembrie",
    "MONTH_12":"decembrie",
    "MONTH_SHORT_1":"ian",
    "MONTH_SHORT_2":"feb",
    "MONTH_SHORT_3":"mar",
    "MONTH_SHORT_4":"apr",
    "MONTH_SHORT_5":"mai",
    "MONTH_SHORT_6":"iun",
    "MONTH_SHORT_7":"iul",
    "MONTH_SHORT_8":"aug",
    "MONTH_SHORT_9":"sep",
    "MONTH_SHORT_10":"oct",
    "MONTH_SHORT_11":"noi",
    "MONTH_SHORT_12":"dec",
    "WK_SUN":"duminică",
    "WK_MON":"luni",
    "WK_TUE":"marți",
    "WK_WED":"miercuri",
    "WK_THU":"joi",
    "WK_FRI":"vineri",
    "WK_SAT":"sâmbătă",
    "WK_7":"duminică",
    "WK_1":"luni",
    "WK_2":"marți",
    "WK_3":"miercuri",
    "WK_4":"joi",
    "WK_5":"vineri",
    "WK_6":"sâmbătă",
    "LBL_DAYS":"zi|zile",
    "LBL_HOURS":"Ore",
    "LBL_MINS":"Minute",
    "LBL_SECONDS":"Secunde",
    "BTN_PROFILE":"Profilul meu",
    "BTN_CHANGE":"Schimbă",
    "BTN_CLIPBOARD":"Copiază"
};
export default strings